import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react';
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import ProductTypesFormContentView from './Includes/ProductTypesFormContentView'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { editFormValidationSchema, initialEditFormValues } from './FormHelper';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { cancelGetProductTypeDetailsApi, editProductType, getProductTypeDetails } from 'utlis/Apis/ProductTypes_API';
import { ERROR_WHILE_UPDATING_PRODUCTTYPE } from 'utlis/AppMessages/AppMessages';
import { PRODUCTTYPE_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_GETTING_PRODUCTTYPE_DETAILS } from 'utlis/AppMessages/AppMessages';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function EditProductType(props) {
    // props
    const { authState } = props

    const submitButtonRef = useRef(null)

    const [editButtonDisable, setEditButtonDisable] = useState(false)
    const [editButtonLoading, setEditButtonLoading] = useState(false)
    const [editProductLoading, setEditProductLoading] = useState(false)
    const [productType, setProductType] = useState({})

    // store url
    const [storeUrl] = useStoreUrl()


    const setFormData = (productTypeData) => {
        setProductType(productTypeData)
    }
    useEffect(() => {
        const attribute_id = props.match.params.id ?? ""
        setEditProductLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getProductTypeDetails(headers, attribute_id).then(res => {
            setEditProductLoading(false)
            const productTypeData = res.data
            if (productTypeData.success) {
                setFormData(productTypeData)
            }
            if (productTypeData.error) {
                console.log(ERROR_WHILE_GETTING_PRODUCTTYPE_DETAILS, res)
                toast.dismiss();
                toast.error(ERROR_WHILE_GETTING_PRODUCTTYPE_DETAILS, {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            setEditProductLoading(true)
            console.log(`${ERROR_WHILE__NAME} getProductTypeDetails `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
            setEditProductLoading(false)
        })

        return () => {
            cancelGetProductTypeDetailsApi()
        }
        // }
    }, [props.match.params.attribute_id, props.location.state, authState])


    const onProductTypeFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setGlobalLoading(true)
            setEditButtonDisable(true)
            setEditButtonLoading(true)
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            editProductType(headers, values).then(res => {
                setGlobalLoading(false)
                setGlobalLoading(false)
                setEditButtonDisable(false)
                setEditButtonLoading(false)
                const addingProductType = res.data
                if (addingProductType.success) {
                    onSuccess(addingProductType.data)
                }
                if (addingProductType.error) {
                    onError(addingProductType)
                }
            }).catch(err => {
                setEditButtonLoading(false)
                console.log(`${ERROR_WHILE__NAME} getProductTypeDetail `, err.message)
                onCatch()
            })
        }
    }
    const onError = (res) => {
        setEditButtonLoading(false)
        console.log(ERROR_WHILE_UPDATING_PRODUCTTYPE, res)
        toast.dismiss();
        toast.error(res.message || ERROR_WHILE_UPDATING_PRODUCTTYPE, {
            autoClose: 3000,
        })
    }
    const onCatch = () => {
        toast.dismiss();
        toast.error(UNKNOWN_ERROR_OCCURED, {
            autoClose: 2500,
            onClose: () => {
                setEditButtonLoading(false)
                setGlobalLoading(false)

            }
        })

    }
    const onSuccess = () => {
        // setEditButtonLoading(true)
        window.scrollTo(0, 0)
        toast.dismiss();
        props.history.push(storeUrl + '/settings/product-types', {
            shouldReload: true
        })

        // setEditButtonLoading(false)

        toast.success(PRODUCTTYPE_UPDATED_SUCCESSFULLY, {
            autoClose: 2000,
            onClose: () => { }
        })
    }

    const formik = useFormik({
        initialValues: initialEditFormValues(productType),
        validationSchema: editFormValidationSchema,
        onSubmit: onProductTypeFormSubmit,
        enableReinitialize: true
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        submitButtonRef.current.click()
    }

    return (
        <section id="app-emails__edit-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-emails__edit-details">
                    <div className="back-button-wrapper mb-2">
                        <Link to={storeUrl + "/settings/product-types"} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                            <FeatherIcon
                                icon="arrow-left"
                                size="14"
                                className="icon me-1" />
                            <span>Back to Product Types</span>
                        </Link>
                    </div>

                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Edit Product Type</p>
                        <p className="app-desc">
                        </p>
                    </div>
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <ProductTypesFormContentView
                                formik={formik}
                                editProductLoading={editProductLoading}
                            />

                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to={storeUrl + "/settings/product-types"} className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(editButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={editButtonDisable || Object.keys(formik.errors).length}
                                        onClick={handleFormSubmission}>
                                        {
                                            editButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Save Changes</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditProductType)